import appProperty from "./app-property.store";
import forgotPassword from "./forgot-password.store";
import menuResource from "./menu-resource.store";
import menuSide from "./menu-side.store";
import menu from "./menu.store";
import resource from "./resource.store";
import roleMenu from "./role-menu.store";
import roleResource from "./role-resource.store";
import role from "./role.store";
import userRole from "./user-role.store";
import user from "./user.store";
import otp from "./otp.store";
import userInstead from "./user-instead.store";
import userSignature from "./user-signature.store";
import securityEvent from "./security-event.store";
import userUsage from "./user-usage.store";

export default {
    appProperty,
    forgotPassword,
    menuResource,
    menuSide,
    menu,
    resource,
    roleMenu,
    roleResource,
    role,
    userRole,
    user,
    otp,
    userInstead,
    userSignature,
    securityEvent,
    userUsage,
};
